import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import PostCard, { fmtDate } from "@/components/PostCard";
import api from "@/lib/api";
import { IMG } from "@/data/profile";

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api.get("/posts", { params: { type: "article" } })
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]));
  }, []);

  const featured = posts?.[0];
  const rest = posts?.slice(1) || [];

  return (
    <main className="pt-28 lg:pt-36">
      <section className="wrap">
        <Reveal>
          <p className="overline-mono">Blog & Articles</p>
          <h1 className="max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl">
            Field notes & opinion.
          </h1>
          <p data-testid="blog-count" className="mt-6 text-[11px] font-semibold uppercase tracking-[0.2em] text-navy-mute">
            {posts === null ? "Opening the journal…" : `${String(posts.length).padStart(2, "0")} essays from the desk`}
          </p>
        </Reveal>

        {featured && (
          <Reveal delay={0.1}>
            <Link
              to={`/writing/${featured.slug}`}
              data-testid="blog-card"
              className="group mt-14 grid border border-line bg-white transition-colors duration-300 hover:border-blue lg:grid-cols-12"
            >
              <div className="relative aspect-[16/10] overflow-hidden lg:col-span-7 lg:aspect-auto lg:min-h-[380px]">
                <img
                  src={featured.cover_url || IMG.hero}
                  alt=""
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <div className="flex flex-col justify-center gap-5 p-8 lg:col-span-5 lg:p-12">
                <div className="flex flex-wrap items-center gap-4 text-[10px] font-semibold uppercase tracking-[0.2em]">
                  <span className="text-blue">Essay</span>
                  <span className="text-navy-mute">{featured.category}</span>
                </div>
                <h2 className="font-serif text-2xl leading-snug text-navy transition-colors duration-300 group-hover:text-blue lg:text-3xl">
                  {featured.title}
                </h2>
                <p className="text-sm leading-relaxed text-navy-soft">{featured.excerpt}</p>
                <p className="border-t border-line pt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-navy-mute">
                  {fmtDate(featured.date)} · {featured.read_time} min read
                </p>
              </div>
            </Link>
          </Reveal>
        )}

        {posts !== null && posts.length === 0 && (
          <p className="py-24 text-center font-serif italic text-2xl text-navy-mute">
            The journal is empty — for now.
          </p>
        )}

        <div className="grid gap-6 py-16 md:grid-cols-2 lg:grid-cols-3 lg:py-20">
          {rest.map((p, i) => (
            <PostCard key={p.slug} post={p} index={i} />
          ))}
        </div>
      </section>
    </main>
  );
}